import React, { useState, useEffect, useRef } from 'react';
import { MovelContratacao, MovelResumo, validarMovel } from '@/components/venda/MovelContratacao';
import LinhasMoveisVenda from '@/components/movel/LinhasMoveisVenda';
import { TvPontosAdicionais, InternetsAdicionais, totalInternetsAdicionais, validarPlanosExtras, temTiposPontoAdicional } from '@/components/venda/PlanosExtras';
import { valorPorPagamento, labelPlano, aplicarFormaPagamento } from '@/components/venda/valorPagamento';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { vendasAPI, produtosAPI, usersAPI, empresasAPI, valoresAPI, cepAPI, formatarErroAPI, formatarTelefoneBR, configSistemaAPI } from '@/lib/api';
import api from '@/lib/api';
import { TurnoToggle } from '@/components/PrevisoesInstalacao';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { ArrowLeft, Save, Lock, Unlock, MessageSquare, History, UserCog, Calendar, Building2, Paperclip, Upload, Download, Trash2, FileText, Image, Loader2, Pencil, X, Send, AlertTriangle, Copy, Phone, MessageCircle, Undo2 } from 'lucide-react';
import EmailSugestao from '@/components/EmailSugestao';
import { NaoPerturbeBadge, NaoPerturbeResumo, lnpDoCampo } from '@/components/NaoPerturbe';
import { CreditoVendaResumo } from '@/components/credito/CreditoVenda';
import { situacao as situacaoCredito } from '@/components/credito/CreditoResultado';
import { ViabilidadeVendaResumo } from '@/components/viabilidade/ViabilidadeVenda';
import { ViabilidadeInline } from '@/components/viabilidade/ViabilidadeInline';
import { resumoViabilidade } from '@/components/viabilidade/servicos';
import { patchPlanoClaro, LABEL_KEY } from '@/components/viabilidade/planoVenda';
import { naoPerturbeAPI, creditoAPI } from '@/lib/api';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Função para formatar CPF: 123.456.789-00
const formatarCPF = (cpf) => {
  if (!cpf) return '-';
  const numeros = cpf.replace(/\D/g, '');
  if (numeros.length !== 11) return cpf;
  return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

// Função para formatar CNPJ: 12.345.678/0001-99
const formatarCNPJ = (cnpj) => {
  if (!cnpj) return '-';
  const numeros = cnpj.replace(/\D/g, '');
  if (numeros.length !== 14) return cnpj;
  return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

// Função para formatar documento (CPF ou CNPJ)
const formatarDocumento = (documento, tipo) => {
  if (!documento) return '-';
  const numeros = documento.replace(/\D/g, '');
  if (tipo === 'CPF' || numeros.length === 11) {
    return formatarCPF(numeros);
  } else if (tipo === 'CNPJ' || numeros.length === 14) {
    return formatarCNPJ(numeros);
  }
  return documento;
};

// Corrigir telefone celular: adiciona o 9 se estiver faltando
const corrigirTelefone = (valor) => {
  if (!valor) return '';
  const nums = valor.replace(/\D/g, '');
  if (nums.length === 10) {
    return nums.slice(0, 2) + '9' + nums.slice(2);
  }
  return nums;
};

const STATUS_COLORS_DEFAULT = {
  'Aguardando Viabilidade': '#8b5cf6',
  'Pendência de Instalação': '#eab308',
  'Desabilitada': '#64748b',
  'Cancelamento': '#ef4444',
  'Reprovada': '#be123c',
  'Devolvida': '#f97316',
  'Instalada': '#10b981',
  'Quebra de Instalação': '#dc2626',
  'Desconectada': '#64748b',
  'Auditoria OK': '#06b6d4',
  'Enviado ao BKO': '#3b82f6',
  'Em Tratamento': '#f59e0b',
  'Bloqueada - Duplicidade': '#991b1b',
};

const DetalhesVenda = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [venda, setVenda] = useState(null);
  const [produtos, setProdutos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [reconsultandoLnp, setReconsultandoLnp] = useState(false);
  const [reconsultandoCredito, setReconsultandoCredito] = useState(false);
  
  // Modal de troca de vendedor
  const [modalTrocaAberto, setModalTrocaAberto] = useState(false);
  const [novoVendedorId, setNovoVendedorId] = useState('');
  const [motivoTroca, setMotivoTroca] = useState('');
  const [trocando, setTrocando] = useState(false);
  
  // Anexos
  const [uploading, setUploading] = useState(false);
  const [thumbnails, setThumbnails] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  
  // Modo edição Devolvida
  const [modoEdicao, setModoEdicao] = useState(false);
  const [planosDisponiveis, setPlanosDisponiveis] = useState([]);
  const [corrigindo, setCorrigindo] = useState(false);
  // Devolução ao vendedor (BKO/Admin sempre; Supervisor só se o admin habilitar)
  const [configSistema, setConfigSistema] = useState({ eu_posso_devolver: false });
  const [dialogDevolver, setDialogDevolver] = useState(false);
  const [motivoDevolucao, setMotivoDevolucao] = useState('');
  const [devolvendo, setDevolvendo] = useState(false);
  useEffect(() => { configSistemaAPI.get().then((r) => setConfigSistema(r.data)).catch(() => {}); }, []);

  const handleDevolver = async () => {
    if (motivoDevolucao.trim().length < 5) { toast.error('Informe o motivo da devolução (mínimo 5 caracteres)'); return; }
    setDevolvendo(true);
    try {
      await vendasAPI.devolver(id, motivoDevolucao.trim());
      toast.success('Venda devolvida ao vendedor para correção');
      setDialogDevolver(false);
      setMotivoDevolucao('');
      loadVenda();
    } catch (error) {
      toast.error(formatarErroAPI(error), { duration: 6000 });
    } finally {
      setDevolvendo(false);
    }
  };
  const [editData, setEditData] = useState(null);

  // Status e Motivos configuráveis
  const [statusDisponiveis, setStatusDisponiveis] = useState([]);
  const [motivosDisponiveis, setMotivosDisponiveis] = useState([]);
  const [statusCores, setStatusCores] = useState({});

  const toUpperCase = (value) => typeof value === 'string' ? value.toUpperCase() : value;
  
  const [formData, setFormData] = useState({
    status: '',
    contrato: '',
    data_instalacao: '',
    horario_instalacao: '',
    chip_iccid: '',
    chip_operadora: '',
    chip_numero_linha: '',
    chip_data_ativacao: '',
    motivo_cancelamento: ''
  });

  const [novaObservacao, setNovaObservacao] = useState('');

  // Consultar CPF automaticamente na edicao (devolvida)
  const [consultandoCpfEdit, setConsultandoCpfEdit] = useState(false);
  const consultarCpfEdit = async (documento) => {
    const nums = documento.replace(/\D/g, '');
    if (nums.length !== 11 || !editData || editData.cliente?.tipo_documento !== 'CPF') return;
    setConsultandoCpfEdit(true);
    try {
      const response = await api.get(`/consulta-cpf/${nums}`);
      const dados = response.data;
      if (dados.nome || dados.data_nascimento || dados.nome_mae) {
        setEditData(prev => ({
          ...prev,
          cliente: {
            ...prev.cliente,
            nome_razao_social: dados.nome ? dados.nome.toUpperCase() : prev.cliente.nome_razao_social,
            data_nascimento: dados.data_nascimento || prev.cliente.data_nascimento,
            nome_mae: dados.nome_mae ? dados.nome_mae.toUpperCase() : prev.cliente.nome_mae,
          }
        }));
        toast.success('Dados do CPF preenchidos automaticamente!');
      }
    } catch (error) {
      console.log('Consulta CPF indisponivel');
    } finally {
      setConsultandoCpfEdit(false);
    }
  };

  useEffect(() => {
    // Carregar tudo em paralelo para reduzir delay
    Promise.all([
      loadVenda(),
      loadVendedores(),
      loadPlanos(),
      loadStatusEMotivos()
    ]);
  }, [id]);

  const loadPlanos = async () => {
    try {
      const response = await valoresAPI.listar({ apenas_ativos: true });
      setPlanosDisponiveis(response.data);
    } catch (error) {
      console.error('Erro ao carregar planos:', error);
    }
  };

  const loadStatusEMotivos = async () => {
    try {
      const [statusRes, motivosRes, statusVendaRes] = await Promise.all([
        api.get('/config/status-disponiveis'),
        api.get('/config/motivos-disponiveis'),
        api.get('/config/status-venda').catch(() => ({ data: [] })),
      ]);
      setStatusDisponiveis(statusRes.data);
      setMotivosDisponiveis(motivosRes.data);
      const cores = { ...STATUS_COLORS_DEFAULT };
      if (statusVendaRes.data) {
        statusVendaRes.data.forEach(s => {
          if (s.cor) {
            cores[s.nome] = s.cor;
            if (s.nome_original) cores[s.nome_original] = s.cor;
          }
        });
      }
      setStatusCores(cores);
    } catch (error) {
      console.error('Erro ao carregar status/motivos:', error);
    }
  };

  const iniciarEdicao = () => {
    if (!venda) return;
    setEditData({
      telefone_venda: venda.telefone_venda || '',
      data_prevista_vendedor: venda.data_prevista_vendedor || '',
      turno_previsto_vendedor: venda.turno_previsto_vendedor || '',
      modalidade_venda: venda.modalidade_venda || venda.tipo_venda || 'Base',
      numero_contrato_cancelamento: venda.numero_contrato_cancelamento || '',
      nome_titular_antigo: venda.nome_titular_antigo || '',
      telefone_titular_antigo: venda.telefone_titular_antigo || '',
      email_titular_antigo: venda.email_titular_antigo || '',
      cpf_cnpj_titular_antigo: venda.cpf_cnpj_titular_antigo || '',
      contrato_cliente_base: venda.contrato_cliente_base || '',
      cliente: {
        tipo_documento: venda.cliente?.tipo_documento || 'CPF',
        documento: venda.cliente?.documento || '',
        nome_razao_social: venda.cliente?.nome_razao_social || '',
        email: venda.cliente?.email || '',
        telefone1: venda.cliente?.telefone1 || '',
        telefone2: venda.cliente?.telefone2 || '',
        nome_mae: venda.cliente?.nome_mae || '',
        rg: venda.cliente?.rg || '',
        data_nascimento: venda.cliente?.data_nascimento || '',
        representante_legal: venda.cliente?.representante_legal || '',
        inscricao_estadual: venda.cliente?.inscricao_estadual || venda.cliente?.administrador || '',
      },
      endereco: {
        cep: venda.endereco?.cep || '',
        endereco: venda.endereco?.endereco || '',
        numero: venda.endereco?.numero || '',
        complemento: venda.endereco?.complemento || '',
        bairro: venda.endereco?.bairro || '',
        cidade: venda.endereco?.cidade || '',
        estado: venda.endereco?.estado || '',
        hp: venda.endereco?.hp || ''
      },
      tipo_venda: venda.tipo_venda || venda.modalidade_venda || 'Base',
      categoria: venda.categoria || 'Residencial',
      produtos_selecionados: venda.produtos_selecionados || (() => {
        const sel = [];
        if (venda.plano_tv_id || venda.plano_tv_nome) sel.push('tv');
        if (venda.plano_internet_id || venda.plano_internet_nome) sel.push('internet');
        if (venda.plano_fixo_id || venda.plano_fixo_nome) sel.push('fixo');
        if (venda.plano_movel_id || venda.plano_movel_nome) sel.push('movel');
        if (venda.plano_alacarte_id || venda.plano_alacarte_nome) sel.push('alacarte');
        if (venda.plano_pontosextra_id || venda.plano_pontosextra_nome) sel.push('pontosextra');
        if (venda.plano_pontosadicionais_id || venda.plano_pontosadicionais_nome) sel.push('pontosadicionais');
        return sel;
      })(),
      planos_adicionais: venda.planos_adicionais || [],
      empresa_id: venda.empresa_id || '',
      plano_tv_id: venda.plano_tv_id || '',
      plano_tv_nome: venda.plano_tv_nome || '',
      plano_tv_valor: venda.plano_tv_valor || 0,
      plano_tv_qtd: venda.plano_tv_qtd || 1,
      plano_internet_id: venda.plano_internet_id || '',
      plano_internet_nome: venda.plano_internet_nome || '',
      plano_internet_valor: venda.plano_internet_valor || 0,
      plano_internet_qtd: venda.plano_internet_qtd || 1,
      plano_fixo_id: venda.plano_fixo_id || '',
      plano_fixo_nome: venda.plano_fixo_nome || '',
      plano_fixo_valor: venda.plano_fixo_valor || 0,
      plano_fixo_qtd: venda.plano_fixo_qtd || 1,
      fixo_tipo_operacao: venda.fixo_tipo_operacao || '',
      fixo_numero_portabilidade: venda.fixo_numero_portabilidade || '',
      fixo_operadora_portabilidade: venda.fixo_operadora_portabilidade || '',
      plano_movel_id: venda.plano_movel_id || '',
      plano_movel_nome: venda.plano_movel_nome || '',
      plano_movel_valor: venda.plano_movel_valor || 0,
      plano_movel_qtd: venda.plano_movel_qtd || 1,
      movel_tipo_operacao: venda.movel_tipo_operacao || '',
      movel_numero_portabilidade: venda.movel_numero_portabilidade || '',
      movel_operadora_portabilidade: venda.movel_operadora_portabilidade || '',
      movel_tipo_migracao: venda.movel_tipo_migracao || '',
      movel_numeros: venda.movel_numeros || [],
      movel_possui_dependentes: typeof venda.movel_possui_dependentes === 'boolean' ? venda.movel_possui_dependentes : null,
      movel_dependentes: venda.movel_dependentes || [],
      movel_numero_migracao: venda.movel_numero_migracao || '',
      movel_cpf_cliente: venda.movel_cpf_cliente || '',
      tt_linhas: venda.tt_linhas && venda.tt_linhas.length > 0 ? venda.tt_linhas : [''],
      plano_alacarte_id: venda.plano_alacarte_id || '',
      plano_alacarte_nome: venda.plano_alacarte_nome || '',
      plano_alacarte_valor: venda.plano_alacarte_valor || 0,
      plano_alacarte_qtd: venda.plano_alacarte_qtd || 1,
      plano_pontosextra_id: venda.plano_pontosextra_id || '',
      plano_pontosextra_nome: venda.plano_pontosextra_nome || '',
      plano_pontosextra_valor: venda.plano_pontosextra_valor || 0,
      plano_pontosextra_qtd: venda.plano_pontosextra_qtd || 1,
      plano_pontosadicionais_id: venda.plano_pontosadicionais_id || '',
      plano_pontosadicionais_nome: venda.plano_pontosadicionais_nome || '',
      plano_pontosadicionais_valor: venda.plano_pontosadicionais_valor || 0,
      plano_pontosadicionais_qtd: venda.plano_pontosadicionais_qtd || 1,
      tv_possui_ponto_adicional: !!(venda.tv_possui_ponto_adicional || venda.plano_pontosadicionais_id || venda.plano_pontosadicionais_nome),
      internets_adicionais: venda.internets_adicionais || [],
      pagamento: {
        forma_pagamento: venda.pagamento?.forma_pagamento || 'Débito',
        vencimento_fatura: venda.pagamento?.vencimento_fatura || '10',
        banco: venda.pagamento?.banco || '',
        agencia: venda.pagamento?.agencia || '',
        conta: venda.pagamento?.conta || ''
      },
      observacoes_campo: venda.observacoes_campo || ''
    });
    setModoEdicao(true);
  };

  // Troca de categoria (vendedor na correção ou BKO/Admin na edição): mesmo comportamento da Nova Venda (zera planos para reescolher)
  const trocarCategoria = (nova) => {
    if (!editData || nova === editData.categoria) return;
    const planosZerados = {};
    ['tv', 'internet', 'fixo', 'movel', 'alacarte', 'pontosextra', 'pontosadicionais'].forEach((t) => {
      planosZerados[`plano_${t}_id`] = '';
      planosZerados[`plano_${t}_nome`] = '';
      planosZerados[`plano_${t}_valor`] = 0;
      planosZerados[`plano_${t}_qtd`] = 1;
    });
    setEditData({ ...editData, categoria: nova, produtos_selecionados: [], planos_adicionais: [], tv_possui_ponto_adicional: false, internets_adicionais: [], ...planosZerados });
    toast.info(`Categoria alterada para ${nova === 'Empresarial' ? 'Empresarial (PJ)' : 'Residencial (PF)'} — selecione novamente os planos`);
  };

  const cancelarEdicao = () => {
    setModoEdicao(false);
    setEditData(null);
  };

  const aplicarPlanoClaroEdicao = (produto, preco, tipoCodigo) => {
    const r = patchPlanoClaro({ produto, preco, tipoCodigo, planosDisponiveis, categoria: editData?.categoria });
    if (!r) { toast.error('Este tipo de produto não tem campo correspondente na venda'); return; }
    setEditData(prev => ({ ...prev, ...r.patch }));
    toast.success(`${LABEL_KEY[r.key]}: ${r.patch[`plano_${r.key}_nome`]} — R$ ${Number(r.patch[`plano_${r.key}_valor`]).toFixed(2)}${r.match ? '' : ' (plano da Claro, fora da tabela de valores)'}`);
  };

  const handleEditPlanoChange = (key, planoId) => {
    if (planoId === 'nenhum') {
      setEditData(prev => ({
        ...prev,
        [`plano_${key}_id`]: '',
        [`plano_${key}_valor`]: 0,
        [`plano_${key}_nome`]: '',
      }));
    } else {
      const plano = planosDisponiveis.find(p => p.id === planoId);
      if (plano) {
        setEditData(prev => ({
          ...prev,
          [`plano_${key}_id`]: plano.id,
          [`plano_${key}_valor`]: valorPorPagamento(plano, prev.pagamento?.forma_pagamento),
          [`plano_${key}_nome`]: plano.nome_plano,
        }));
      }
    }
  };

  const trocarFormaPagamentoEdit = (forma) => {
    const { patch, alterados } = aplicarFormaPagamento(editData, forma, planosDisponiveis);
    setEditData(prev => ({ ...prev, ...patch }));
    if (alterados > 0) toast.info(`Valores dos planos ajustados para ${forma === 'Boleto' ? 'boleto' : 'débito automático'}`);
  };

  const editValorTotal = editData ? (
    (editData.plano_tv_valor || 0) * (editData.plano_tv_qtd || 1) +
    (editData.plano_internet_valor || 0) * (editData.plano_internet_qtd || 1) +
    (editData.plano_fixo_valor || 0) * (editData.plano_fixo_qtd || 1) +
    (editData.plano_movel_valor || 0) * (editData.plano_movel_qtd || 1) +
    (editData.plano_alacarte_valor || 0) * (editData.plano_alacarte_qtd || 1) +
    (editData.plano_pontosextra_valor || 0) * (editData.plano_pontosextra_qtd || 1) +
    (editData.plano_pontosadicionais_valor || 0) * (editData.plano_pontosadicionais_qtd || 1) +
    totalInternetsAdicionais(editData)
  ) : 0;

  const handleEditCEPChange = async (cep) => {
    setEditData(prev => ({ ...prev, endereco: { ...prev.endereco, cep } }));
    if (cep.replace(/\D/g, '').length === 8) {
      try {
        const response = await cepAPI.buscar(cep);
        if (!response.data.erro) {
          setEditData(prev => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              endereco: response.data.logradouro,
              bairro: (response.data.bairro || '').toUpperCase(),
              cidade: (response.data.localidade || '').toUpperCase(),
              estado: response.data.uf
            }
          }));
          toast.success('CEP encontrado!');
        }
      } catch (error) {
        toast.error('CEP não encontrado');
      }
    }
  };

  const handleSalvarCorrecao = async () => {
    if (!editData) return;

    // Validar que pelo menos um plano/serviço foi selecionado
    const temPlano = ['tv', 'internet', 'fixo', 'movel', 'alacarte', 'pontosextra', 'pontosadicionais']
      .some(key => editData[`plano_${key}_id`] && editData[`plano_${key}_id`] !== 'nenhum');
    if (!temPlano) {
      toast.error('Selecione pelo menos um serviço em Planos e Valores');
      return;
    }
    if (editData.plano_movel_id && editData.plano_movel_id !== 'nenhum') {
      const erroMovel = validarMovel(editData);
      if (erroMovel) { toast.error(erroMovel); return; }
    }
    const erroExtras = validarPlanosExtras(editData, temTiposPontoAdicional(planosDisponiveis, editData.categoria));
    if (erroExtras) { toast.error(erroExtras); return; }

    setCorrigindo(true);
    try {
      // Corrigir telefones automaticamente antes de enviar
      const editCorrigido = {
        ...editData,
        telefone_venda: corrigirTelefone(editData.telefone_venda),
        telefone_titular_antigo: corrigirTelefone(editData.telefone_titular_antigo),
        cliente: {
          ...editData.cliente,
          telefone1: corrigirTelefone(editData.cliente?.telefone1),
          telefone2: corrigirTelefone(editData.cliente?.telefone2),
        }
      };
      const dadosEnviar = {
        ...editCorrigido,
        valor_plano: editValorTotal,
      };
      if (venda?.status === 'Devolvida') {
        await vendasAPI.corrigir(id, dadosEnviar);
        toast.success('Venda corrigida e reenviada ao BKO!');
      } else {
        await vendasAPI.update(id, dadosEnviar);
        toast.success('Venda atualizada com sucesso!');
      }
      setModoEdicao(false);
      setEditData(null);
      loadVenda();
    } catch (error) {
      toast.error(formatarErroAPI(error), { duration: 6000 });
    } finally {
      setCorrigindo(false);
    }
  };

  const loadVenda = async () => {
    setLoading(true);
    try {
      const [vendaResponse, produtosResponse, empresasResponse] = await Promise.all([
        vendasAPI.get(id),
        produtosAPI.list(),
        empresasAPI.list()
      ]);
      
      setVenda(vendaResponse.data);
      setProdutos(produtosResponse.data);
      setEmpresas(empresasResponse.data);
      
      setFormData({
        status: vendaResponse.data.status,
        contrato: vendaResponse.data.contrato || '',
        data_instalacao: vendaResponse.data.data_instalacao || '',
        horario_instalacao: vendaResponse.data.horario_instalacao || '',
        chip_iccid: vendaResponse.data.chip_iccid || '',
        chip_operadora: vendaResponse.data.chip_operadora || '',
        chip_numero_linha: vendaResponse.data.chip_numero_linha || '',
        chip_data_ativacao: vendaResponse.data.chip_data_ativacao || '',
        motivo_cancelamento: vendaResponse.data.motivo_cancelamento || ''
      });
    } catch (error) {
      toast.error('Erro ao carregar venda');
      navigate('/vendas');
    } finally {
      setLoading(false);
    }
  };

  // Load thumbnails for image attachments
  const loadThumbnails = async (anexos) => {
    if (!anexos || anexos.length === 0) return;
    const imageAnexos = anexos.filter(a => a.tipo_arquivo?.startsWith('image/'));
    const newThumbs = {};
    await Promise.all(imageAnexos.map(async (anexo) => {
      try {
        const response = await vendasAPI.downloadAnexo(id, anexo.id);
        if (response.data && response.data.size > 0) {
          newThumbs[anexo.id] = URL.createObjectURL(response.data);
        }
      } catch (e) {
        // silently fail for thumbnails
      }
    }));
    setThumbnails(prev => ({ ...prev, ...newThumbs }));
  };

  useEffect(() => {
    const anexos = venda?.anexos;
    if (anexos && anexos.length > 0) {
      loadThumbnails(anexos);
    }
    return () => {
      // cleanup thumbnails on unmount
      setThumbnails(prev => {
        Object.values(prev).forEach(url => URL.revokeObjectURL(url));
        return {};
      });
    };
  }, [venda?.anexos?.length]); // eslint-disable-line

  const getEmpresaNome = (empresaId) => {
    const empresa = empresas.find(e => e.id === empresaId);
    return empresa?.nome || '-';
  };

  // Função para mascarar contrato (Vendedor vê mascarado, BKO/Admin vê completo)
  const mascararContrato = (contrato) => {
    if (!contrato) return null;
    
    // Converter para string e remover ".0" se existir (quando vem como número)
    let contratoStr = String(contrato);
    if (contratoStr.endsWith('.0')) {
      contratoStr = contratoStr.slice(0, -2);
    }
    
    // Se for Admin ou BKO, mostra completo
    if (user?.perfil === 'ADMIN' || user?.perfil === 'BKO' || user?.perfil === 'BKO_MAILING') return contratoStr;
    // Se for Vendedor, mascara mostrando apenas últimos 4 dígitos
    if (contratoStr.length <= 4) return contratoStr;
    return '****' + contratoStr.slice(-4);
  };

  const loadVendedores = async () => {
    try {
      const response = await usersAPI.listVendedores();
      const vendedoresAtivos = response.data.filter(u => u.ativo);
      setVendedores(vendedoresAtivos);
    } catch (error) {
      console.error('Erro ao carregar vendedores:', error);
    }
  };

  const handleBloquear = async () => {
    try {
      await vendasAPI.bloquear(id);
      toast.success('Venda bloqueada para tratamento');
      loadVenda();
    } catch (error) {
      toast.error(formatarErroAPI(error), { duration: 5000 });
    }
  };

  const handleDesbloquear = async () => {
    try {
      await vendasAPI.desbloquear(id);
      toast.success('Venda desbloqueada');
      loadVenda();
    } catch (error) {
      toast.error(formatarErroAPI(error), { duration: 5000 });
    }
  };

  const handleSalvar = async () => {
    if (formData.status === 'Cancelamento' && motivosDisponiveis.length > 0 && !formData.motivo_cancelamento) {
      toast.error('Selecione o motivo do cancelamento');
      return;
    }
    setSalvando(true);
    try {
      await vendasAPI.update(id, formData);
      toast.success('Venda atualizada com sucesso!');
      if (formData.status === 'Instalada') {
        setTimeout(() => {
          toast.success('Parabens! Venda INSTALADA com sucesso! Excelente trabalho!', { duration: 6000 });
        }, 500);
      } else if (formData.status === 'Gerada') {
        setTimeout(() => {
          toast.success('Parabens! Venda GERADA com sucesso! Continue assim!', { duration: 6000 });
        }, 500);
      }
      loadVenda();
    } catch (error) {
      toast.error(formatarErroAPI(error), { duration: 5000 });
    } finally {
      setSalvando(false);
    }
  };

  const handleAdicionarObservacao = async () => {
    if (!novaObservacao.trim()) {
      toast.error('Digite uma observação');
      return;
    }

    try {
      await vendasAPI.addObservacao(id, novaObservacao);
      toast.success('Observação adicionada!');
      setNovaObservacao('');
      loadVenda();
    } catch (error) {
      toast.error('Erro ao adicionar observação');
    }
  };

  const handleTrocarVendedor = async () => {
    if (!novoVendedorId) {
      toast.error('Selecione um vendedor');
      return;
    }
    if (!motivoTroca.trim()) {
      toast.error('Informe o motivo da troca');
      return;
    }

    setTrocando(true);
    try {
      await vendasAPI.trocarVendedor(id, {
        novo_vendedor_id: novoVendedorId,
        motivo: motivoTroca
      });
      toast.success('Vendedor trocado com sucesso!');
      setModalTrocaAberto(false);
      setNovoVendedorId('');
      setMotivoTroca('');
      loadVenda();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao trocar vendedor');
    } finally {
      setTrocando(false);
    }
  };

  const podeEditar = user?.perfil === 'ADMIN' || user?.perfil === 'BKO' || user?.perfil === 'BKO_MAILING';
  const podeDevolver = venda && venda.status !== 'Devolvida' && (podeEditar || user?.perfil === 'GERENTE' || (user?.perfil === 'SUPERVISOR' && !!configSistema.eu_posso_devolver));
  const podeCorrigirDevolvida = venda?.status === 'Devolvida';
  // BKO/Admin editam a venda completa (planos, valores, categoria PF/PJ) sem alterar o status
  const podeEditarCompleto = podeEditar && !podeCorrigirDevolvida;

  // Funções de Anexos
  const handleUploadAnexo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validar tipo de arquivo
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Tipo de arquivo não permitido. Use: PNG, JPG, GIF, WEBP ou PDF');
      return;
    }

    // Validar tamanho (10MB)
    if (file.size > 10 * 1024 * 1024) {
      toast.error('Arquivo muito grande. Máximo: 10MB');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      
      await vendasAPI.uploadAnexo(id, formData);
      toast.success('Anexo enviado com sucesso!');
      loadVenda();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao enviar anexo');
    } finally {
      setUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleDownloadAnexo = async (anexo) => {
    try {
      const response = await vendasAPI.downloadAnexo(id, anexo.id);
      
      // Verificar se a resposta tem dados
      if (!response.data || response.data.size === 0) {
        toast.error('Arquivo não encontrado no servidor');
        return;
      }
      
      const blob = new Blob([response.data], { type: anexo.tipo_arquivo || 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = anexo.nome_arquivo;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('Download iniciado!');
    } catch (error) {
      console.error('Erro ao baixar anexo:', error);
      toast.error(error.response?.data?.detail || 'Erro ao baixar anexo. Arquivo pode não existir.');
    }
  };

  const handleExcluirAnexo = async (anexo) => {
    if (!window.confirm(`Excluir o anexo "${anexo.nome_arquivo}"?`)) return;
    
    try {
      await vendasAPI.excluirAnexo(id, anexo.id);
      toast.success('Anexo excluído!');
      loadVenda();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao excluir anexo');
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getFileIcon = (tipoArquivo) => {
    if (tipoArquivo.startsWith('image/')) {
      return <Image className="h-5 w-5 text-red-500" />;
    }
    return <FileText className="h-5 w-5 text-red-500" />;
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
        <p className="text-gray-500 mt-4">Carregando venda...</p>
      </div>
    );
  }

  if (!venda) {
    return (
      <div className="max-w-2xl mx-auto text-center py-12">
        <div className="bg-red-50 border border-red-200 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Venda não encontrada</h2>
          <p className="text-gray-600 mb-6">A venda que você está tentando acessar não existe ou foi removida.</p>
          <Button onClick={() => navigate('/vendas')} className="bg-red-600 hover:bg-red-700">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para Vendas
          </Button>
        </div>
      </div>
    );
  }

  // Garantir que os objetos aninhados existem
  const vendaSegura = {
    ...venda,
    cliente: venda.cliente || {},
    endereco: venda.endereco || {},
    produtos: venda.produtos || [],
    anexos: venda.anexos || [],
    historico: venda.historico || [],
    bloqueio: venda.bloqueio || {},
    pagamento: venda.pagamento || {},
  };

  const copiarTexto = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      toast.success('Copiado!');
    }).catch(() => toast.error('Erro ao copiar'));
  };

  const lnp = (campo) => lnpDoCampo(vendaSegura.nao_perturbe, campo);
  const LnpBadge = ({ campo, telefone }) => (telefone ? <NaoPerturbeBadge info={lnp(campo)} consultadoEm={vendaSegura.nao_perturbe?.consultado_em} testid={`lnp-${campo.replace('.', '-')}`} /> : null);

  const reconsultarNaoPerturbe = async () => {
    setReconsultandoLnp(true);
    try {
      const res = await naoPerturbeAPI.reconsultarVenda(vendaSegura.id);
      setVenda((v) => ({ ...v, nao_perturbe: res.data }));
      toast.success(res.data.bloqueados ? `${res.data.bloqueados} telefone(s) na lista Não Perturbe` : 'Todos os telefones liberados');
    } catch (err) {
      toast.error(formatarErroAPI(err));
    } finally {
      setReconsultandoLnp(false);
    }
  };

  const reconsultarCredito = async () => {
    setReconsultandoCredito(true);
    try {
      const res = await creditoAPI.reconsultarVenda(vendaSegura.id);
      setVenda((v) => ({ ...v, credito: res.data }));
      if (res.data?.status === 'ok') {
        const s = situacaoCredito(res.data.resultado, res.data.mensagem);
        toast[s.tom === 'verde' ? 'success' : 'warning'](`Crédito ${s.label} na Claro`);
      } else toast.error(res.data?.mensagem || 'Não foi possível consultar o crédito');
    } catch (err) {
      toast.error(formatarErroAPI(err));
    } finally {
      setReconsultandoCredito(false);
    }
  };

  const CopyBtn = ({ texto }) => (
    <button type="button" onClick={() => copiarTexto(texto)} className="ml-2 text-gray-400 hover:text-red-600 transition-colors inline-flex items-center" title="Copiar">
      <Copy className="h-3.5 w-3.5" />
    </button>
  );

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button variant="outline" onClick={() => navigate('/vendas')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Protocolo: {vendaSegura.protocolo || '-'}
            </h1>
            <p className="text-gray-500 mt-1">Detalhes da venda</p>
          </div>
        </div>
      </div>

      {/* Status e Bloqueio */}
      <div className="flex gap-3 flex-wrap items-center">
        <Badge variant="outline" className="text-xs border-0" style={{ backgroundColor: statusCores[vendaSegura.status] || '#9ca3af', color: '#fff' }}>
          {vendaSegura.status || 'Sem status'}
        </Badge>
        {vendaSegura.modalidade_venda && (
          <Badge className={vendaSegura.modalidade_venda === 'TT' ? 'bg-orange-500 text-white' : 'bg-red-500 text-white'}>
            {vendaSegura.modalidade_venda}
          </Badge>
        )}
        {vendaSegura.bloqueio?.bloqueado && (
          <Badge className="bg-orange-100 text-orange-800">
            🔒 Em tratamento por: {vendaSegura.bloqueio.usuario_bloqueio}
          </Badge>
        )}

        {/* Botão WhatsApp */}
        {vendaSegura.cliente?.telefone1 && (
          <a
            href={`https://wa.me/55${(vendaSegura.cliente.telefone1 || '').replace(/\D/g, '')}?text=${encodeURIComponent(
              `Olá ${vendaSegura.cliente?.nome_razao_social || 'Cliente'}! Aqui é da *Multi Telecom*.\n\n` +
              `Referente ao protocolo *${vendaSegura.protocolo || ''}*.\n` +
              (vendaSegura.status ? `Status atual: *${vendaSegura.status}*\n` : '') +
              `\nPrecisamos tratar sobre sua solicitação. Podemos conversar?`
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg transition-colors shadow-sm"
            data-testid="btn-whatsapp"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            WhatsApp
          </a>
        )}

        {podeCorrigirDevolvida && !modoEdicao && (
          <Button onClick={iniciarEdicao} className="ml-auto bg-amber-600 hover:bg-amber-700" data-testid="btn-corrigir-venda">
            <Pencil className="mr-2 h-4 w-4" />
            Corrigir Venda
          </Button>
        )}
        {podeDevolver && !modoEdicao && (
          <Button onClick={() => setDialogDevolver(true)} variant="outline" className={`${podeEditarCompleto ? '' : 'ml-auto '}border-amber-500 text-amber-400 hover:bg-amber-900/30`} data-testid="btn-devolver-venda">
            <Undo2 className="mr-2 h-4 w-4" />
            Devolver ao Vendedor
          </Button>
        )}
        {podeEditarCompleto && !modoEdicao && (
          <Button onClick={iniciarEdicao} variant="outline" className="ml-auto border-purple-500 text-purple-300 hover:bg-purple-900/40" data-testid="btn-editar-venda">
            <Pencil className="mr-2 h-4 w-4" />
            Editar Venda
          </Button>
        )}
        {modoEdicao && (
          <div className="ml-auto flex gap-2">
            <Button variant="outline" onClick={cancelarEdicao} data-testid="btn-cancelar-edicao">
              <X className="mr-2 h-4 w-4" />
              Cancelar
            </Button>
            <Button onClick={handleSalvarCorrecao} disabled={corrigindo} className="bg-green-600 hover:bg-green-700" data-testid="btn-salvar-correcao">
              {corrigindo ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
              {corrigindo ? 'Salvando...' : podeCorrigirDevolvida ? 'Enviar Correção ao BKO' : 'Salvar Alterações'}
            </Button>
          </div>
        )}
      </div>

      {/* Lei Não Perturbe */}
      <NaoPerturbeResumo resultado={vendaSegura.nao_perturbe} onReconsultar={reconsultarNaoPerturbe} carregando={reconsultandoLnp} />

      {/* Checagem de crédito Claro */}
      <CreditoVendaResumo credito={vendaSegura.credito} onReconsultar={reconsultarCredito} carregando={reconsultandoCredito} />

      {/* Viabilidade consultada na Nova Venda */}
      <ViabilidadeVendaResumo viabilidade={vendaSegura.viabilidade} />

      {/* Banner de Devolvida */}
      {podeCorrigirDevolvida && !modoEdicao && (
        <Card className="border-amber-400 bg-amber-50">
          <CardContent className="py-4">
            <p className="text-amber-800 font-medium text-center">
              Esta venda foi devolvida. Clique em <strong>"Corrigir Venda"</strong> para editar as informações e reenviar ao BKO.
            </p>
          </CardContent>
        </Card>
      )}

      {/* Informações Iniciais */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Informações Iniciais</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Telefone da Venda *</Label>
                <Input
                  value={editData.telefone_venda}
                  onChange={(e) => setEditData({...editData, telefone_venda: e.target.value})}
                  onBlur={(e) => {
                    if (e.target.value) setEditData(prev => ({...prev, telefone_venda: corrigirTelefone(e.target.value)}));
                  }}
                  placeholder="(00) 00000-0000"
                  data-testid="edit-telefone-venda"
                />
              </div>
              <div>
                <Label>Tipo de Venda *</Label>
                <Select
                  value={editData.modalidade_venda}
                  onValueChange={(v) => setEditData({...editData, modalidade_venda: v, tipo_venda: v})}
                >
                  <SelectTrigger data-testid="edit-modalidade">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Base">Base</SelectItem>
                    <SelectItem value="TT">TT</SelectItem>
                    <SelectItem value="Proposta">Proposta</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Categoria (PF/PJ) *</Label>
                <Select
                  value={editData.categoria || 'Residencial'}
                  onValueChange={trocarCategoria}
                >
                  <SelectTrigger data-testid="edit-categoria"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Residencial">Residencial (PF)</SelectItem>
                    <SelectItem value="Empresarial">Empresarial (PJ)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>Informações Iniciais</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <Label className="text-gray-600">Telefone da Venda</Label>
                <p className="font-semibold flex flex-wrap items-center gap-1.5" data-testid="telefone-venda">{vendaSegura.telefone_venda || '-'}<CopyBtn texto={vendaSegura.telefone_venda || ''} /><LnpBadge campo="telefone_venda" telefone={vendaSegura.telefone_venda} /></p>
              </div>
              <div>
                <Label className="text-gray-600">Tipo de Venda</Label>
                <p className="font-semibold" data-testid="modalidade-venda">{vendaSegura.tipo_venda || vendaSegura.modalidade_venda || '-'}<CopyBtn texto={vendaSegura.tipo_venda || vendaSegura.modalidade_venda || ''} /></p>
              </div>
              <div>
                <Label className="text-gray-600">Categoria</Label>
                <p className="font-semibold" data-testid="categoria-venda">{vendaSegura.categoria || 'Residencial'}<CopyBtn texto={vendaSegura.categoria || 'Residencial'} /></p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Dados da Base - Contrato do Cliente */}
      {modoEdicao && ['Base', 'BASE'].includes(editData.modalidade_venda) && (
        <Card className="border-red-300 bg-red-50">
          <CardHeader>
            <CardTitle className="text-red-800">Dados da Base - Contrato do Cliente</CardTitle>
          </CardHeader>
          <CardContent>
            <div>
              <Label>Contrato do Cliente *</Label>
              <Input
                value={editData.contrato_cliente_base}
                onChange={(e) => setEditData({...editData, contrato_cliente_base: toUpperCase(e.target.value)})}
                placeholder="Numero do contrato do cliente"
                className="uppercase"
                data-testid="edit-contrato-base"
              />
            </div>
          </CardContent>
        </Card>
      )}
      {!modoEdicao && ['Base', 'BASE'].includes(vendaSegura.modalidade_venda) && vendaSegura.contrato_cliente_base && (
        <Card className="border-red-300 bg-red-50">
          <CardHeader>
            <CardTitle className="text-red-800">Dados da Base - Contrato do Cliente</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="p-3 bg-white rounded-lg border border-red-200">
              <Label className="text-red-600 text-sm font-medium">Contrato do Cliente</Label>
              <p className="font-bold text-lg mt-1" data-testid="contrato-cliente-base">{vendaSegura.contrato_cliente_base}</p>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Dados TT (Cancelamento) */}
      {modoEdicao && editData.modalidade_venda === 'TT' && (
        <Card className="border-orange-300 bg-orange-50">
          <CardHeader>
            <CardTitle className="text-orange-700">Dados do Titular Antigo (Cancelamento)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Numero do Contrato Antigo *</Label>
                <Input
                  value={editData.numero_contrato_cancelamento}
                  onChange={(e) => setEditData({...editData, numero_contrato_cancelamento: e.target.value.replace(/\D/g, '')})}
                  data-testid="edit-contrato-cancelamento"
                />
              </div>
              <div>
                <Label>Nome do Titular Antigo *</Label>
                <Input
                  value={editData.nome_titular_antigo}
                  onChange={(e) => setEditData({...editData, nome_titular_antigo: toUpperCase(e.target.value)})}
                  className="uppercase"
                  data-testid="edit-nome-titular-antigo"
                />
              </div>
              <div>
                <Label>Telefone do Titular Antigo *</Label>
                <Input
                  value={editData.telefone_titular_antigo}
                  onChange={(e) => setEditData({...editData, telefone_titular_antigo: e.target.value})}
                  onBlur={(e) => {
                    if (e.target.value) setEditData(prev => ({...prev, telefone_titular_antigo: corrigirTelefone(e.target.value)}));
                  }}
                  data-testid="edit-tel-titular-antigo"
                />
              </div>
              <div>
                <Label>E-mail do Titular Antigo</Label>
                <Input
                  type="email"
                  value={editData.email_titular_antigo}
                  onChange={(e) => setEditData({...editData, email_titular_antigo: e.target.value.toLowerCase()})}
                  data-testid="edit-email-titular-antigo"
                />
              </div>
              <div>
                <Label>CPF/CNPJ do Cliente Anterior *</Label>
                <Input
                  value={editData.cpf_cnpj_titular_antigo}
                  onChange={(e) => setEditData({...editData, cpf_cnpj_titular_antigo: e.target.value.replace(/\D/g, '')})}
                  placeholder="Somente números"
                  maxLength={14}
                  data-testid="edit-cpf-cnpj-titular-antigo"
                />
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {!modoEdicao && vendaSegura.modalidade_venda === 'TT' && (
        <Card className="border-orange-300 bg-orange-50">
          <CardHeader>
            <CardTitle className="text-orange-700">📋 Dados do Titular Antigo (TT - Cancelamento)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="p-3 bg-white rounded-lg border border-orange-200">
                <Label className="text-orange-600 text-sm font-medium">Nº Contrato Antigo</Label>
                <p className="font-bold text-lg mt-1">
                  {vendaSegura.numero_contrato_cancelamento || <span className="text-gray-400 italic text-base">Não informado</span>}
                </p>
              </div>
              <div className="p-3 bg-white rounded-lg border border-orange-200">
                <Label className="text-orange-600 text-sm font-medium">Nome do Titular Antigo</Label>
                <p className="font-semibold mt-1">
                  {vendaSegura.nome_titular_antigo || <span className="text-gray-400 italic text-base">Não informado</span>}
                </p>
              </div>
              <div className="p-3 bg-white rounded-lg border border-orange-200">
                <Label className="text-orange-600 text-sm font-medium">Telefone Titular Antigo</Label>
                <p className="font-semibold mt-1 flex flex-wrap items-center gap-1.5">
                  {vendaSegura.telefone_titular_antigo || <span className="text-gray-400 italic text-base">Não informado</span>}
                  <LnpBadge campo="telefone_titular_antigo" telefone={vendaSegura.telefone_titular_antigo} />
                </p>
              </div>
              <div className="p-3 bg-white rounded-lg border border-orange-200">
                <Label className="text-orange-600 text-sm font-medium">E-mail Titular Antigo</Label>
                <p className="font-semibold mt-1 text-sm break-all">
                  {vendaSegura.email_titular_antigo || <span className="text-gray-400 italic text-base">Não informado</span>}
                </p>
              </div>
              <div className="p-3 bg-white rounded-lg border border-orange-200">
                <Label className="text-orange-600 text-sm font-medium">CPF/CNPJ Cliente Anterior</Label>
                <p className="font-bold text-lg mt-1" data-testid="view-cpf-cnpj-titular-antigo">
                  {vendaSegura.cpf_cnpj_titular_antigo || <span className="text-gray-400 italic text-base">Não informado</span>}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Dados do Cliente */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Dados do Cliente</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Tipo de Documento *</Label>
                <Select
                  value={editData.cliente.tipo_documento}
                  onValueChange={(v) => setEditData({...editData, cliente: {...editData.cliente, tipo_documento: v}})}
                >
                  <SelectTrigger data-testid="edit-tipo-doc"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="CPF">CPF</SelectItem>
                    <SelectItem value="CNPJ">CNPJ</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>CPF/CNPJ *</Label>
                <Input
                  value={editData.cliente.documento}
                  onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, documento: e.target.value.replace(/\D/g, '')}})}
                  onBlur={(e) => {
                    const nums = e.target.value.replace(/\D/g, '');
                    if (editData.cliente.tipo_documento === 'CPF' && nums.length === 11) {
                      consultarCpfEdit(nums);
                    }
                  }}
                  placeholder={editData.cliente.tipo_documento === 'CPF' ? '000.000.000-00' : '00.000.000/0000-00'}
                  data-testid="edit-documento"
                />
              </div>
              <div className="md:col-span-2">
                <Label>Nome / Razao Social *</Label>
                <Input
                  value={editData.cliente.nome_razao_social}
                  onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, nome_razao_social: toUpperCase(e.target.value)}})}
                  className={`uppercase ${consultandoCpfEdit ? 'animate-pulse bg-gray-50' : ''}`}
                  disabled={consultandoCpfEdit}
                  data-testid="edit-nome"
                />
              </div>
              <div>
                <Label>E-mail</Label>
                <EmailSugestao
                  value={editData.cliente.email}
                  onChange={(val) => setEditData({...editData, cliente: {...editData.cliente, email: val}})}
                  data-testid="edit-email"
                />
              </div>
              <div>
                <Label>Telefone 1 *</Label>
                <Input
                  value={editData.cliente.telefone1}
                  onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, telefone1: e.target.value}})}
                  onBlur={(e) => {
                    if (e.target.value) setEditData(prev => ({...prev, cliente: {...prev.cliente, telefone1: corrigirTelefone(e.target.value)}}));
                  }}
                  data-testid="edit-tel1"
                />
              </div>
              <div>
                <Label>Telefone 2 *</Label>
                <Input
                  value={editData.cliente.telefone2}
                  onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, telefone2: e.target.value}})}
                  onBlur={(e) => {
                    if (e.target.value) setEditData(prev => ({...prev, cliente: {...prev.cliente, telefone2: corrigirTelefone(e.target.value)}}));
                  }}
                  data-testid="edit-tel2"
                />
              </div>
              {editData.cliente.tipo_documento === 'CPF' && (
                <>
                  <div>
                    <Label>Nome da Mae *</Label>
                    <Input
                      value={editData.cliente.nome_mae}
                      onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, nome_mae: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-nome-mae"
                    />
                  </div>
                  <div>
                    <Label>RG *</Label>
                    <Input
                      value={editData.cliente.rg}
                      onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, rg: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-rg"
                    />
                  </div>
                  <div>
                    <Label>Data de Nascimento *</Label>
                    <Input
                      type="date"
                      value={editData.cliente.data_nascimento}
                      onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, data_nascimento: e.target.value}})}
                      data-testid="edit-data-nasc"
                    />
                  </div>
                </>
              )}
              {editData.cliente.tipo_documento === 'CNPJ' && (
                <>
                  <div>
                    <Label>Representante Legal</Label>
                    <Input
                      value={editData.cliente.representante_legal}
                      onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, representante_legal: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-representante"
                    />
                  </div>
                  <div>
                    <Label>Inscricao Estadual</Label>
                    <Input
                      value={editData.cliente.inscricao_estadual || editData.cliente.administrador || ''}
                      onChange={(e) => setEditData({...editData, cliente: {...editData.cliente, inscricao_estadual: e.target.value.replace(/\D/g, '')}})}
                      data-testid="edit-inscricao-estadual"
                    />
                  </div>
                </>
              )}
            </div>
          </CardContent>
        </Card>
      ) : (
      <Card>
        <CardHeader>
          <CardTitle>Dados do Cliente</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label className="text-gray-600">Nome/Razao Social</Label>
              <p className="font-semibold">{vendaSegura.cliente?.nome_razao_social || '-'}<CopyBtn texto={vendaSegura.cliente?.nome_razao_social || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Documento ({vendaSegura.cliente?.tipo_documento || '-'})</Label>
              <p className="font-semibold">{formatarDocumento(vendaSegura.cliente?.documento, vendaSegura.cliente?.tipo_documento)}<CopyBtn texto={vendaSegura.cliente?.documento || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">E-mail</Label>
              <p className="font-semibold">{vendaSegura.cliente?.email || '-'}<CopyBtn texto={vendaSegura.cliente?.email || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Telefone 1</Label>
              <div className="flex flex-wrap items-center gap-1">
                <p className="font-semibold">{vendaSegura.cliente?.telefone1 || '-'}<CopyBtn texto={vendaSegura.cliente?.telefone1 || ''} /></p>
                {vendaSegura.cliente?.telefone1 && (
                  <>
                    <a href={`tel:+55${(vendaSegura.cliente.telefone1 || '').replace(/\D/g, '')}`} title="Ligar" className="ml-1 p-1 rounded hover:bg-blue-100 text-blue-600"><Phone className="w-4 h-4" /></a>
                    <a href={`https://wa.me/55${(vendaSegura.cliente.telefone1 || '').replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" title="WhatsApp" className="p-1 rounded hover:bg-green-100 text-green-600"><MessageCircle className="w-4 h-4" /></a>
                    <LnpBadge campo="cliente.telefone1" telefone={vendaSegura.cliente.telefone1} />
                  </>
                )}
              </div>
            </div>
            {vendaSegura.cliente?.telefone2 && (
              <div>
                <Label className="text-gray-600">Telefone 2</Label>
                <div className="flex flex-wrap items-center gap-1">
                  <p className="font-semibold">{vendaSegura.cliente.telefone2}<CopyBtn texto={vendaSegura.cliente.telefone2} /></p>
                  <a href={`tel:+55${(vendaSegura.cliente.telefone2 || '').replace(/\D/g, '')}`} title="Ligar" className="ml-1 p-1 rounded hover:bg-blue-100 text-blue-600"><Phone className="w-4 h-4" /></a>
                  <a href={`https://wa.me/55${(vendaSegura.cliente.telefone2 || '').replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" title="WhatsApp" className="p-1 rounded hover:bg-green-100 text-green-600"><MessageCircle className="w-4 h-4" /></a>
                  <LnpBadge campo="cliente.telefone2" telefone={vendaSegura.cliente.telefone2} />
                </div>
              </div>
            )}
            {vendaSegura.cliente?.tipo_documento === 'CPF' && (
              <>
                <div>
                  <Label className="text-gray-600">Nome da Mae</Label>
                  <p className="font-semibold">{vendaSegura.cliente?.nome_mae || <span className="text-gray-400 italic">Nao informado</span>}<CopyBtn texto={vendaSegura.cliente?.nome_mae || ''} /></p>
                </div>
                <div>
                  <Label className="text-gray-600">RG</Label>
                  <p className="font-semibold">{vendaSegura.cliente?.rg || <span className="text-gray-400 italic">Nao informado</span>}<CopyBtn texto={vendaSegura.cliente?.rg || ''} /></p>
                </div>
                <div>
                  <Label className="text-gray-600">Data de Nascimento</Label>
                  <p className="font-semibold">
                    {vendaSegura.cliente?.data_nascimento 
                      ? format(new Date(vendaSegura.cliente.data_nascimento + 'T00:00:00'), "dd/MM/yyyy", { locale: ptBR })
                      : <span className="text-gray-400 italic">Nao informado</span>
                    }
                    <CopyBtn texto={vendaSegura.cliente?.data_nascimento ? format(new Date(vendaSegura.cliente.data_nascimento + 'T00:00:00'), "dd/MM/yyyy", { locale: ptBR }) : ''} />
                  </p>
                </div>
              </>
            )}
            {vendaSegura.cliente?.tipo_documento === 'CNPJ' && (
              <>
                {vendaSegura.cliente?.representante_legal && (
                  <div>
                    <Label className="text-gray-600">Representante Legal</Label>
                    <p className="font-semibold">{vendaSegura.cliente.representante_legal}<CopyBtn texto={vendaSegura.cliente.representante_legal} /></p>
                  </div>
                )}
                {(vendaSegura.cliente?.inscricao_estadual || vendaSegura.cliente?.administrador) && (
                  <div>
                    <Label className="text-gray-600">Inscricao Estadual</Label>
                    <p className="font-semibold">{vendaSegura.cliente.inscricao_estadual || vendaSegura.cliente.administrador}<CopyBtn texto={vendaSegura.cliente.inscricao_estadual || vendaSegura.cliente.administrador} /></p>
                  </div>
                )}
              </>
            )}
          </div>
        </CardContent>
      </Card>
      )}

      {/* Endereço */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Endereço</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>CEP *</Label>
                <Input
                  value={editData.endereco.cep}
                  onChange={(e) => handleEditCEPChange(e.target.value)}
                  placeholder="00000-000"
                  data-testid="edit-cep"
                />
              </div>
              <div className="md:col-span-2">
                <Label>Endereço *</Label>
                <Input
                  value={editData.endereco.endereco}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, endereco: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-endereco"
                />
              </div>
              <div>
                <Label>Numero *</Label>
                <Input
                  value={editData.endereco.numero}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, numero: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-numero"
                />
              </div>
              <div>
                <Label>Complemento</Label>
                <Input
                  value={editData.endereco.complemento}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, complemento: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-complemento"
                />
              </div>
              <div>
                <Label>Bairro</Label>
                <Input
                  value={editData.endereco.bairro}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, bairro: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-bairro"
                />
              </div>
              <div>
                <Label>Cidade *</Label>
                <Input
                  value={editData.endereco.cidade}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, cidade: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-cidade"
                />
              </div>
              <div>
                <Label>Estado *</Label>
                <Input
                  value={editData.endereco.estado}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, estado: toUpperCase(e.target.value)}})}
                  maxLength={2}
                  className="uppercase"
                  data-testid="edit-estado"
                />
              </div>
              <div>
                <Label>HP</Label>
                <Input
                  value={editData.endereco.hp}
                  onChange={(e) => setEditData({...editData, endereco: {...editData.endereco, hp: toUpperCase(e.target.value)}})}
                  className="uppercase"
                  data-testid="edit-hp"
                />
              </div>
            </div>
            <div className="mt-4">
              <ViabilidadeInline
                cep={editData.endereco.cep}
                numero={editData.endereco.numero}
                cidade={editData.endereco.cidade}
                uf={editData.endereco.estado}
                complemento={editData.endereco.complemento}
                tipoCliente={editData.categoria === 'Empresarial' ? 'EMPRESARIAL' : 'RESIDENCIAL'}
                credito={vendaSegura.credito?.status === 'ok' ? vendaSegura.credito : null}
                planos={{
                  tv: !!editData.plano_tv_id,
                  internet: !!editData.plano_internet_id || (editData.internets_adicionais || []).length > 0,
                  fixo: !!editData.plano_fixo_id,
                }}
                onEscolherPlano={aplicarPlanoClaroEdicao}
                onResultado={(d) => setEditData((prev) => (!prev || !d ? prev : {
                  ...prev,
                  viabilidade: resumoViabilidade(d, user?.nome),
                  endereco: { ...prev.endereco, hp: String(d.hp) },
                }))}
                onPreencherEndereco={(d) => setEditData((prev) => (!prev ? prev : {
                  ...prev,
                  endereco: {
                    ...prev.endereco,
                    cep: d.cep ? d.cep.replace(/\D/g, '').replace(/^(\d{5})(\d{3})$/, '$1-$2') : prev.endereco.cep,
                    endereco: (d.logradouro || prev.endereco.endereco || '').toUpperCase(),
                    numero: d.numero || prev.endereco.numero,
                    complemento: (d.complementos || '').toUpperCase(),
                    bairro: (d.bairro || prev.endereco.bairro || '').toUpperCase(),
                    cidade: (d.cidade || prev.endereco.cidade || '').toUpperCase(),
                    estado: (d.uf || prev.endereco.estado || '').toUpperCase(),
                    hp: String(d.hp),
                  },
                }))}
                testid="viab-inline-edicao"
              />
            </div>
          </CardContent>
        </Card>
      ) : (
      <Card>
        <CardHeader>
          <CardTitle>Endereço</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <Label className="text-gray-600">CEP</Label>
              <p className="font-semibold">{vendaSegura.endereco?.cep || '-'}<CopyBtn texto={vendaSegura.endereco?.cep || ''} /></p>
            </div>
            <div className="lg:col-span-2">
              <Label className="text-gray-600">Endereco</Label>
              <p className="font-semibold">{vendaSegura.endereco?.endereco || '-'}, {vendaSegura.endereco?.numero || '-'}<CopyBtn texto={`${vendaSegura.endereco?.endereco || ''}, ${vendaSegura.endereco?.numero || ''}`} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Complemento</Label>
              <p className="font-semibold">{vendaSegura.endereco?.complemento || <span className="text-gray-400 italic">Nao informado</span>}<CopyBtn texto={vendaSegura.endereco?.complemento || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Bairro</Label>
              <p className="font-semibold" data-testid="bairro">{String(vendaSegura.endereco?.bairro || '').toUpperCase() || <span className="text-gray-400 italic">Nao informado</span>}<CopyBtn texto={vendaSegura.endereco?.bairro || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Cidade</Label>
              <p className="font-semibold">{String(vendaSegura.endereco?.cidade || '').toUpperCase() || '-'}<CopyBtn texto={vendaSegura.endereco?.cidade || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Estado</Label>
              <p className="font-semibold">{vendaSegura.endereco?.estado || '-'}<CopyBtn texto={vendaSegura.endereco?.estado || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">HP</Label>
              <p className="font-semibold">{vendaSegura.endereco?.hp || <span className="text-gray-400 italic">Nao informado</span>}<CopyBtn texto={vendaSegura.endereco?.hp || ''} /></p>
            </div>
          </div>
        </CardContent>
      </Card>
      )}

      {/* Informações da Venda */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Informações da Venda</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Categoria (PF/PJ) *</Label>
                <Select
                  value={editData.categoria || 'Residencial'}
                  onValueChange={trocarCategoria}
                >
                  <SelectTrigger data-testid="edit-categoria-info"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Residencial">Residencial (PF)</SelectItem>
                    <SelectItem value="Empresarial">Empresarial (PJ)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Empresa *</Label>
                <Select
                  value={editData.empresa_id}
                  onValueChange={(v) => setEditData({...editData, empresa_id: v})}
                >
                  <SelectTrigger data-testid="edit-empresa"><SelectValue placeholder="Selecione" /></SelectTrigger>
                  <SelectContent>
                    {empresas.filter(emp => emp.ativo !== false || emp.id === editData.empresa_id).map((emp) => (
                      <SelectItem key={emp.id} value={emp.id}>{emp.nome}{emp.ativo === false ? ' (Inativa)' : ''}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
      <Card>
        <CardHeader>
          <CardTitle>Informacoes da Venda</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label className="text-gray-600">Vendedor</Label>
              <p className="font-semibold" data-testid="vendedor-nome">{vendaSegura.vendedor_nome || '-'}<CopyBtn texto={vendaSegura.vendedor_nome || ''} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Empresa</Label>
              <p className="font-semibold" data-testid="empresa-nome">{getEmpresaNome(vendaSegura.empresa_id)}<CopyBtn texto={getEmpresaNome(vendaSegura.empresa_id)} /></p>
            </div>
            <div>
              <Label className="text-gray-600">Data de Cadastro</Label>
              <p className="font-semibold">
                {vendaSegura.criado_em ? format(new Date(vendaSegura.criado_em), "dd/MM/yyyy 'as' HH:mm", { locale: ptBR }) : '-'}
                <CopyBtn texto={vendaSegura.criado_em ? format(new Date(vendaSegura.criado_em), "dd/MM/yyyy HH:mm") : ''} />
              </p>
            </div>
            <div>
              <Label className="text-gray-600">Usuario de Tratamento</Label>
              <p className="font-semibold">
                {vendaSegura.usuario_tratamento || <span className="text-gray-400 italic">Aguardando tratamento</span>}
                <CopyBtn texto={vendaSegura.usuario_tratamento || ''} />
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      )}

      {/* Planos e Valores */}
      {modoEdicao ? (
        <Card className="border-gray-200">
          <CardHeader>
            <CardTitle className="text-gray-800">Planos e Valores</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { tipo: 'TV', key: 'tv', label: 'TV' },
                { tipo: 'INTERNET', key: 'internet', label: 'Internet' },
                { tipo: 'FIXO', key: 'fixo', label: 'Fixo' },
                { tipo: 'MOVEL', key: 'movel', label: 'Movel' },
                { tipo: 'A LA CARTE', key: 'alacarte', label: 'A La Carte' },
                { tipo: 'PONTOS EXTRA', key: 'pontosextra', label: 'Pontos Extra' },
              ].map(({ tipo, key, label }) => {
                const planosTipo = planosDisponiveis.filter(p => p.tipo === tipo && p.categoria === editData.categoria);
                const planoId = editData[`plano_${key}_id`];
                const planoValor = editData[`plano_${key}_valor`];
                const planoQtd = editData[`plano_${key}_qtd`] || 1;
                return (
                  <div key={tipo} className="space-y-1.5">
                    <Label className="text-sm">{label}</Label>
                    <div className="flex gap-2">
                      <Select
                        value={planoId || 'nenhum'}
                        onValueChange={(v) => handleEditPlanoChange(key, v)}
                      >
                        <SelectTrigger data-testid={`edit-plano-${key}`} className="flex-1">
                          <SelectValue placeholder={`Selecione ${label}...`} />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="nenhum">Nenhum</SelectItem>
                          {planoId?.startsWith('claro-') && (
                            <SelectItem value={planoId} data-testid={`edit-plano-${key}-opcao-claro`}>
                              {editData[`plano_${key}_nome`]} (R$ {Number(editData[`plano_${key}_valor`] || 0).toFixed(2)}) • Claro
                            </SelectItem>
                          )}
                          {planosTipo.map(p => (
                            <SelectItem key={p.id} value={p.id}>
                              {labelPlano(p, editData.pagamento?.forma_pagamento)}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      {planoId && planoId !== 'nenhum' && (
                        <Input
                          type="number"
                          min={1}
                          value={planoQtd}
                          onChange={(e) => setEditData({...editData, [`plano_${key}_qtd`]: Math.max(1, parseInt(e.target.value) || 1)})}
                          className="w-16 text-center"
                          data-testid={`edit-plano-${key}-qtd`}
                        />
                      )}
                    </div>
                    {planoValor > 0 && (
                      <p className="text-xs text-gray-600 font-semibold">
                        R$ {planoValor.toFixed(2)} x {planoQtd} = R$ {(planoValor * planoQtd).toFixed(2)}
                      </p>
                    )}
                    {key === 'tv' && planoId && planoId !== 'nenhum' && (
                      <TvPontosAdicionais data={editData} onChange={(patch) => setEditData(prev => ({ ...prev, ...patch }))} planosDisponiveis={planosDisponiveis} categoria={editData.categoria} formaPagamento={editData.pagamento?.forma_pagamento} />
                    )}
                    {key === 'internet' && planoId && planoId !== 'nenhum' && (
                      <InternetsAdicionais data={editData} onChange={(patch) => setEditData(prev => ({ ...prev, ...patch }))} planosDisponiveis={planosDisponiveis} categoria={editData.categoria} formaPagamento={editData.pagamento?.forma_pagamento} />
                    )}
                    {/* Campos condicionais Fixo */}
                    {key === 'fixo' && planoId && planoId !== 'nenhum' && (
                      <div className="mt-2 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border space-y-2">
                        <Label className="text-xs font-semibold">Tipo de Operação</Label>
                        <div className="flex gap-2">
                          {['Linha Nova', 'Portabilidade'].map(op => (
                            <button key={op} type="button"
                              onClick={() => setEditData(prev => ({
                                ...prev, fixo_tipo_operacao: prev.fixo_tipo_operacao === op ? '' : op,
                                fixo_numero_portabilidade: op !== 'Portabilidade' ? '' : prev.fixo_numero_portabilidade,
                                fixo_operadora_portabilidade: op !== 'Portabilidade' ? '' : prev.fixo_operadora_portabilidade,
                              }))}
                              className={`px-3 py-1 rounded text-xs font-medium border ${editData.fixo_tipo_operacao === op ? 'bg-red-600 text-white border-red-600' : 'bg-white text-gray-600 border-gray-300'}`}
                            >{op}</button>
                          ))}
                        </div>
                        {editData.fixo_tipo_operacao === 'Portabilidade' && (
                          <div className="grid grid-cols-2 gap-2">
                            <div><Label className="text-xs">Número com DDD</Label><Input value={editData.fixo_numero_portabilidade} onChange={(e) => setEditData({...editData, fixo_numero_portabilidade: e.target.value})} placeholder="(00) 0000-0000" /></div>
                            <div><Label className="text-xs">Operadora</Label><Input value={editData.fixo_operadora_portabilidade} onChange={(e) => setEditData({...editData, fixo_operadora_portabilidade: e.target.value})} placeholder="Oi, Vivo..." /></div>
                          </div>
                        )}
                      </div>
                    )}
                    {/* Campos condicionais Móvel */}
                    {key === 'movel' && planoId && planoId !== 'nenhum' && (
                      <MovelContratacao
                        data={editData}
                        onChange={(patch) => setEditData(prev => ({ ...prev, ...patch }))}
                        plano={planosDisponiveis.find(p => p.id === planoId)}
                        tipoVenda={editData.tipo_venda}
                      />
                    )}
                  </div>
                );
              })}
            </div>

            <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 flex justify-between items-center">
              <span className="text-lg font-semibold text-gray-800">Valor Total (calculado automaticamente):</span>
              <span className="text-2xl font-bold text-gray-700" data-testid="edit-valor-total">
                R$ {editValorTotal.toFixed(2)}
              </span>
            </div>
          </CardContent>
        </Card>
      ) : (
      <Card className="border-gray-200">
        <CardHeader>
          <CardTitle className="text-gray-800">Planos e Valores</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[
              { key: 'tv', label: 'TV', icon: '📺' },
              { key: 'internet', label: 'Internet', icon: '🌐' },
              { key: 'fixo', label: 'Fixo', icon: '☎️' },
              { key: 'movel', label: 'Móvel', icon: '📱' },
              { key: 'alacarte', label: 'A La Carte', icon: '🎬' },
              { key: 'pontosextra', label: 'Pontos Extra', icon: '➕' },
              { key: 'pontosadicionais', label: 'Pontos Adicionais (TV)', icon: '📡' },
            ].map(({ key, label, icon }) => {
              const nome = vendaSegura[`plano_${key}_nome`];
              const valor = vendaSegura[`plano_${key}_valor`];
              const qtd = vendaSegura[`plano_${key}_qtd`] || 1;
              if (!nome && !valor) return null;
              return (
                <div key={key} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" data-testid={`plano-detalhe-${key}`}>
                  <div className="flex items-center gap-3">
                    <span className="text-lg">{icon}</span>
                    <div>
                      <p className="font-semibold text-gray-900">{label} {qtd > 1 && <span className="text-gray-600">({qtd}x)</span>}</p>
                      <p className="text-sm text-gray-600">{nome || '-'}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    {qtd > 1 && <p className="text-[10px] text-gray-500">{qtd} x R$ {parseFloat(valor || 0).toFixed(2)}</p>}
                    <span className="font-bold text-gray-700">R$ {(parseFloat(valor || 0) * qtd).toFixed(2)}</span>
                  </div>
                </div>
              );
            })}
            {(vendaSegura.internets_adicionais || []).filter(i => i.nome).map((i, idx) => (
              <div key={`inet-${idx}`} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" data-testid={`plano-detalhe-internet-adicional-${idx}`}>
                <div className="flex items-center gap-3">
                  <span className="text-lg">🌐</span>
                  <div>
                    <p className="font-semibold text-gray-900">Internet adicional {idx + 2} {(i.qtd || 1) > 1 && <span className="text-gray-600">({i.qtd}x)</span>}</p>
                    <p className="text-sm text-gray-600">{i.nome}</p>
                  </div>
                </div>
                <span className="font-bold text-gray-700">R$ {(parseFloat(i.valor || 0) * (i.qtd || 1)).toFixed(2)}</span>
              </div>
            ))}
            {/* Fallback: se nenhum plano novo, mostrar produtos antigos */}
            {!vendaSegura.plano_tv_nome && !vendaSegura.plano_internet_nome && !vendaSegura.plano_fixo_nome && !vendaSegura.plano_movel_nome && !vendaSegura.plano_alacarte_nome && !vendaSegura.plano_pontosextra_nome && !vendaSegura.plano_pontosadicionais_nome && vendaSegura.produtos && vendaSegura.produtos.length > 0 && (
              vendaSegura.produtos.map((produtoId) => {
                const produto = produtos.find(p => p.id === produtoId);
                return produto ? (
                  <div key={produtoId} className="flex items-center gap-3 p-3 bg-red-50 rounded-lg border border-red-200">
                    <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    <div>
                      <p className="font-semibold text-gray-900">{produto.nome}</p>
                      <p className="text-sm text-gray-600">{produto.categoria}</p>
                    </div>
                  </div>
                ) : null;
              })
            )}
            {!vendaSegura.plano_tv_nome && !vendaSegura.plano_internet_nome && !vendaSegura.plano_fixo_nome && !vendaSegura.plano_movel_nome && !vendaSegura.plano_alacarte_nome && !vendaSegura.plano_pontosextra_nome && !vendaSegura.plano_pontosadicionais_nome && (!vendaSegura.produtos || vendaSegura.produtos.length === 0) && (
              <p className="text-gray-500 italic col-span-2">Nenhum plano selecionado</p>
            )}
          </div>

          {/* Detalhes Fixo */}
          {vendaSegura.fixo_tipo_operacao && (
            <div className="mt-3 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700">
              <p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Detalhes Fixo</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <Label className="text-gray-500 text-xs">Tipo de Operação</Label>
                  <p className="font-semibold text-sm">{vendaSegura.fixo_tipo_operacao}</p>
                </div>
                {vendaSegura.fixo_tipo_operacao === 'Portabilidade' && (
                  <>
                    <div>
                      <Label className="text-gray-500 text-xs">Número com DDD</Label>
                      <p className="font-semibold text-sm">{vendaSegura.fixo_numero_portabilidade || '-'}</p>
                    </div>
                    <div>
                      <Label className="text-gray-500 text-xs">Operadora</Label>
                      <p className="font-semibold text-sm">{vendaSegura.fixo_operadora_portabilidade || '-'}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Detalhes Móvel */}
          <MovelResumo venda={vendaSegura} />

          {/* Valor Total */}
          <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 flex justify-between items-center">
            <span className="text-lg font-semibold text-gray-800">Valor Total:</span>
            <span className="text-2xl font-bold text-gray-700" data-testid="valor-total-detalhes">
              R$ {parseFloat(vendaSegura.valor_plano || 0).toFixed(2)}
            </span>
          </div>
        </CardContent>
      </Card>
      )}

      {/* Linhas móveis da venda (aba Móvel) */}
      {!modoEdicao && <LinhasMoveisVenda vendaId={vendaSegura.id} temMovel={!!(vendaSegura.plano_movel_id || vendaSegura.plano_movel_nome)} />}

      <Dialog open={dialogDevolver} onOpenChange={(v) => { if (!devolvendo) setDialogDevolver(v); }}>
        <DialogContent className="sm:max-w-lg" data-testid="dialog-devolver-venda">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-amber-500"><Undo2 className="h-5 w-5" /> Devolver venda {vendaSegura.protocolo} ao vendedor</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-gray-500">A venda ficará com status <strong>Devolvida</strong>; {vendaSegura.vendedor_nome} será notificado(a) e poderá corrigir e reenviar ao BKO.</p>
          <div className="space-y-1">
            <Label htmlFor="motivo-devolucao">Motivo da devolução *</Label>
            <Textarea id="motivo-devolucao" rows={4} value={motivoDevolucao} onChange={(e) => setMotivoDevolucao(e.target.value)} placeholder="Ex.: CPF divergente do documento, endereço incompleto, plano incorreto..." data-testid="textarea-motivo-devolucao" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDialogDevolver(false)} disabled={devolvendo} data-testid="btn-cancelar-devolver">Cancelar</Button>
            <Button onClick={handleDevolver} disabled={devolvendo || motivoDevolucao.trim().length < 5} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="btn-confirmar-devolver">
              {devolvendo ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Undo2 className="mr-2 h-4 w-4" />}
              Devolver
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Informações de Pagamento */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Informações de Pagamento</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Forma de Pagamento *</Label>
                <Select
                  value={editData.pagamento.forma_pagamento}
                  onValueChange={(v) => trocarFormaPagamentoEdit(v)}
                >
                  <SelectTrigger data-testid="edit-forma-pgto"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Débito">Debito</SelectItem>
                    <SelectItem value="Boleto">Boleto</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Vencimento da Fatura *</Label>
                <Select
                  value={editData.pagamento.vencimento_fatura}
                  onValueChange={(v) => setEditData({...editData, pagamento: {...editData.pagamento, vencimento_fatura: v}})}
                >
                  <SelectTrigger data-testid="edit-vencimento"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="05">Dia 05</SelectItem>
                    <SelectItem value="08">Dia 08</SelectItem>
                    <SelectItem value="10">Dia 10</SelectItem>
                    <SelectItem value="15">Dia 15</SelectItem>
                    <SelectItem value="20">Dia 20</SelectItem>
                    <SelectItem value="25">Dia 25</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              {editData.pagamento.forma_pagamento === 'Débito' && (
                <>
                  <div>
                    <Label>Banco</Label>
                    <Input
                      value={editData.pagamento.banco}
                      onChange={(e) => setEditData({...editData, pagamento: {...editData.pagamento, banco: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-banco"
                    />
                  </div>
                  <div>
                    <Label>Agencia</Label>
                    <Input
                      value={editData.pagamento.agencia}
                      onChange={(e) => setEditData({...editData, pagamento: {...editData.pagamento, agencia: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-agencia"
                    />
                  </div>
                  <div>
                    <Label>Conta</Label>
                    <Input
                      value={editData.pagamento.conta}
                      onChange={(e) => setEditData({...editData, pagamento: {...editData.pagamento, conta: toUpperCase(e.target.value)}})}
                      className="uppercase"
                      data-testid="edit-conta"
                    />
                  </div>
                </>
              )}
              <div className="md:col-span-2">
                <Label>Data prevista 100% (vendedor)</Label>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3 mt-1">
                  <Input
                    type="date"
                    value={editData.data_prevista_vendedor || ''}
                    onChange={(e) => setEditData({...editData, data_prevista_vendedor: e.target.value})}
                    className="max-w-xs"
                    data-testid="edit-data-prevista-vendedor"
                  />
                  <TurnoToggle
                    value={editData.turno_previsto_vendedor || ''}
                    onChange={(t) => setEditData({...editData, turno_previsto_vendedor: t})}
                    testidPrefix="edit-turno-vendedor"
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
      <Card>
        <CardHeader>
          <CardTitle>Informações de Pagamento</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <Label className="text-gray-600">Forma de Pagamento</Label>
              <p className="font-semibold">{vendaSegura.pagamento?.forma_pagamento || <span className="text-gray-400 italic">Não informado</span>}</p>
            </div>
            <div>
              <Label className="text-gray-600">Vencimento da Fatura</Label>
              <p className="font-semibold">{vendaSegura.pagamento?.vencimento_fatura ? `Dia ${vendaSegura.pagamento.vencimento_fatura}` : <span className="text-gray-400 italic">Não informado</span>}</p>
            </div>
            {vendaSegura.pagamento?.forma_pagamento === 'Débito' && (
              <>
                <div>
                  <Label className="text-gray-600">Banco</Label>
                  <p className="font-semibold">{vendaSegura.pagamento?.banco || <span className="text-gray-400 italic">Não informado</span>}</p>
                </div>
                <div>
                  <Label className="text-gray-600">Agência</Label>
                  <p className="font-semibold">{vendaSegura.pagamento?.agencia || <span className="text-gray-400 italic">Não informado</span>}</p>
                </div>
                <div>
                  <Label className="text-gray-600">Conta</Label>
                  <p className="font-semibold">{vendaSegura.pagamento?.conta || <span className="text-gray-400 italic">Não informado</span>}</p>
                </div>
              </>
            )}
            <div>
              <Label className="text-gray-600">Data Prevista 100% (Vendedor)</Label>
              <div className="font-semibold flex items-center gap-2" data-testid="pagamento-previsao-vendedor">
                {vendaSegura.data_prevista_vendedor
                  ? format(new Date(vendaSegura.data_prevista_vendedor + 'T00:00:00'), 'dd/MM/yyyy')
                  : <span className="text-gray-400 italic">Não informada</span>}
                {vendaSegura.turno_previsto_vendedor && <Badge variant="outline" className="text-xs">{vendaSegura.turno_previsto_vendedor}</Badge>}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      )}

      {/* Observações do Campo (editável em modo edição) */}
      {modoEdicao ? (
        <Card className="border-amber-300">
          <CardHeader>
            <CardTitle>Observações do Campo</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={editData.observacoes_campo}
              onChange={(e) => setEditData({...editData, observacoes_campo: e.target.value})}
              rows={3}
              placeholder="Observações sobre a venda..."
              data-testid="edit-observacoes-campo"
            />
          </CardContent>
        </Card>
      ) : null}

      {/* Botões flutuantes de edição no final */}
      {modoEdicao && (
        <Card className="border-green-300 bg-green-50 dark:border-green-800 dark:bg-green-900/20">
          <CardContent className="py-4">
            <div className="flex justify-between items-center">
              <p className="text-green-800 dark:text-green-200 font-medium">Revise as alterações e envie ao BKO.</p>
              <div className="flex gap-2">
                <Button variant="outline" onClick={cancelarEdicao} className="bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-100 dark:hover:bg-gray-800" data-testid="btn-cancelar-edicao-bottom">
                  <X className="mr-2 h-4 w-4" />
                  Cancelar
                </Button>
                <Button onClick={handleSalvarCorrecao} disabled={corrigindo} className="bg-green-600 hover:bg-green-700" data-testid="btn-salvar-correcao-bottom">
                  {corrigindo ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
                  {corrigindo ? 'Enviando...' : 'Enviar Correção ao BKO'}
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Campos Editáveis (BKO/Admin) */}
      {podeEditar && (
        <Card>
          <CardHeader>
            <CardTitle>Atualizar Venda</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Status</Label>
                <Select
                  value={formData.status}
                  onValueChange={(value) => setFormData({ ...formData, status: value, motivo_cancelamento: value === 'Cancelamento' ? formData.motivo_cancelamento : '' })}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {(statusDisponiveis.length > 0 ? statusDisponiveis : Object.keys(STATUS_COLORS_DEFAULT)).map((status) => (
                      <SelectItem key={status} value={status}>
                        {status}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {formData.status === 'Cancelamento' && motivosDisponiveis.length > 0 && (
                <div>
                  <Label>Motivo do Cancelamento *</Label>
                  <Select
                    value={formData.motivo_cancelamento || 'none'}
                    onValueChange={(value) => setFormData({ ...formData, motivo_cancelamento: value === 'none' ? '' : value })}
                  >
                    <SelectTrigger data-testid="select-motivo-cancelamento">
                      <SelectValue placeholder="Selecione o motivo" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Selecione...</SelectItem>
                      {motivosDisponiveis.map((motivo) => (
                        <SelectItem key={motivo} value={motivo}>{motivo}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              <div>
                <Label>Nº Contrato</Label>
                <Input
                  value={formData.contrato}
                  onChange={(e) => setFormData({ ...formData, contrato: e.target.value })}
                  placeholder="Digite o número do contrato"
                />
              </div>

              <div>
                <Label>Data de Instalação <span className="text-xs text-gray-500 font-normal">(oficial BKO/CRM)</span></Label>
                <Input
                  type="date"
                  value={formData.data_instalacao}
                  onChange={(e) => setFormData({ ...formData, data_instalacao: e.target.value })}
                  data-testid="bko-data-instalacao"
                />
                {vendaSegura.data_prevista_vendedor && (
                  <p className="text-[11px] text-gray-500 mt-1">
                    Previsão do vendedor: {format(new Date(vendaSegura.data_prevista_vendedor + 'T00:00:00'), 'dd/MM/yyyy')}
                    {vendaSegura.turno_previsto_vendedor && ` (${vendaSegura.turno_previsto_vendedor})`}
                    {!formData.data_instalacao && (
                      <button type="button" className="ml-2 text-red-600 underline" onClick={() => setFormData({ ...formData, data_instalacao: vendaSegura.data_prevista_vendedor })} data-testid="bko-usar-data-vendedor">
                        usar esta data
                      </button>
                    )}
                  </p>
                )}
              </div>

              <div>
                <Label>Horário de Instalação</Label>
                <Select
                  value={formData.horario_instalacao || 'none'}
                  onValueChange={(value) => setFormData({ ...formData, horario_instalacao: value === 'none' ? '' : value })}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione o horário" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">Nenhum</SelectItem>
                    <SelectItem value="08:00 - 12:00">08:00 - 12:00</SelectItem>
                    <SelectItem value="12:00 - 15:00">12:00 - 15:00</SelectItem>
                    <SelectItem value="15:00 - 18:00">15:00 - 18:00</SelectItem>
                    <SelectItem value="12:00 - 18:00">12:00 - 18:00</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            {/* Botões de Ação */}
            <div className="flex flex-wrap gap-3 mt-6 pt-4 border-t">
              <Button variant="outline" onClick={() => setModalTrocaAberto(true)} className="text-orange-600 border-orange-300 hover:bg-orange-50">
                <UserCog className="mr-2 h-4 w-4" />
                Trocar Vendedor
              </Button>
              {!vendaSegura.bloqueio?.bloqueado ? (
                <Button variant="outline" onClick={handleBloquear}>
                  <Lock className="mr-2 h-4 w-4" />
                  Bloquear
                </Button>
              ) : (
                <Button variant="outline" onClick={handleDesbloquear}>
                  <Unlock className="mr-2 h-4 w-4" />
                  Desbloquear
                </Button>
              )}
              <Button onClick={handleSalvar} disabled={salvando} className="bg-red-600 hover:bg-red-700">
                <Save className="mr-2 h-4 w-4" />
                {salvando ? 'Salvando...' : 'Salvar Alterações'}
              </Button>
            </div>
          </CardContent>
        </Card>
      )}


      {/* Motivo de Cancelamento - visível para todos (read-only) */}
      {!modoEdicao && vendaSegura.motivo_cancelamento && (
        <Card className="border-red-200 bg-red-50/30">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-red-700">
              <AlertTriangle className="h-5 w-5" />
              Motivo de Cancelamento
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-red-800 font-semibold text-lg" data-testid="motivo-cancelamento-display">{vendaSegura.motivo_cancelamento}</p>
          </CardContent>
        </Card>
      )}

      {/* Observações do Campo (formulário inicial) - read only */}
      {!modoEdicao && vendaSegura.observacoes_campo && (
        <Card className="border-amber-200 bg-amber-50/30">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-amber-700">
              <FileText className="h-5 w-5" />
              Observações do Campo
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-800 whitespace-pre-wrap" data-testid="observacoes-campo">{vendaSegura.observacoes_campo}</p>
          </CardContent>
        </Card>
      )}

      {/* Observações */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5" />
            Observações
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {/* Lista de Observações Existentes */}
            {vendaSegura.observacoes && vendaSegura.observacoes.length > 0 ? (
              <div className="space-y-3 mb-4">
                {vendaSegura.observacoes.map((obs, index) => (
                  <div key={index} className="border-l-4 border-red-500 pl-4 py-2 bg-red-50 rounded-r">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-semibold text-sm text-red-700">{obs.usuario}</span>
                      <span className="text-xs text-gray-500">
                        {obs.data_hora ? format(new Date(obs.data_hora), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR }) : ''}
                      </span>
                    </div>
                    <p className="text-gray-700">{obs.texto}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 italic mb-4">Nenhuma observação registrada</p>
            )}

            {/* Adicionar Nova Observação */}
            <div className="pt-4 border-t">
              <Label className="text-gray-700 font-medium">Adicionar Observação</Label>
              <Textarea
                value={novaObservacao}
                onChange={(e) => setNovaObservacao(e.target.value)}
                placeholder="Digite sua observação sobre a venda..."
                rows={3}
                className="mt-2"
              />
              <Button 
                onClick={handleAdicionarObservacao} 
                className="mt-3 bg-red-600 hover:bg-red-700"
                disabled={!novaObservacao.trim()}
              >
                <MessageSquare className="mr-2 h-4 w-4" />
                Adicionar Observação
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Dados de Instalação - Visualização para todos */}
      <Card className="border-gray-200 bg-gray-50/30">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-gray-700">
            <Calendar className="h-5 w-5" />
            Dados de Instalação
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 bg-white rounded-lg border border-gray-200">
              <Label className="text-gray-600 text-sm font-medium">Número do Contrato</Label>
              <p className="font-semibold text-lg mt-1">
                {mascararContrato(vendaSegura.contrato) || <span className="text-gray-400 italic text-base">Aguardando...</span>}
              </p>
            </div>
            <div className="p-4 bg-white rounded-lg border border-gray-200">
              <Label className="text-gray-600 text-sm font-medium">Data de Instalação (Agenda)</Label>
              <p className="font-semibold text-lg mt-1">
                {vendaSegura.data_instalacao 
                  ? format(new Date(vendaSegura.data_instalacao + 'T00:00:00'), "dd/MM/yyyy", { locale: ptBR })
                  : <span className="text-gray-400 italic text-base">Aguardando...</span>
                }
              </p>
            </div>
            <div className="p-4 bg-white rounded-lg border border-gray-200">
              <Label className="text-gray-600 text-sm font-medium">Horário de Instalação</Label>
              <p className="font-semibold text-lg mt-1">
                {vendaSegura.horario_instalacao || <span className="text-gray-400 italic text-base">Aguardando...</span>}
              </p>
            </div>
          </div>
          {!vendaSegura.contrato && !vendaSegura.data_instalacao && (
            <p className="text-sm text-gray-500 mt-3 italic">
              * Esses dados serão preenchidos pelo BKO/Admin durante o tratamento da venda.
            </p>
          )}
        </CardContent>
      </Card>

      {/* Anexos */}
      <Card className="border-red-200 bg-red-50/30">
        <CardHeader>
          <CardTitle className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-red-700">
              <Paperclip className="h-5 w-5" />
              Anexos ({vendaSegura.anexos?.length || 0})
            </div>
            <div>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleUploadAnexo}
                accept=".png,.jpg,.jpeg,.gif,.webp,.pdf"
                className="hidden"
              />
              <Button
                size="sm"
                onClick={() => fileInputRef.current?.click()}
                disabled={uploading}
                className="bg-red-600 hover:bg-red-700"
              >
                {uploading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Enviando...
                  </>
                ) : (
                  <>
                    <Upload className="mr-2 h-4 w-4" />
                    Anexar Arquivo
                  </>
                )}
              </Button>
            </div>
          </CardTitle>
        </CardHeader>
        <CardContent>
          {vendaSegura.anexos && vendaSegura.anexos.length > 0 ? (
            <div className="space-y-3">
              {/* Grid de imagens */}
              {vendaSegura.anexos.some(a => a.tipo_arquivo?.startsWith('image/')) && (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-4">
                  {vendaSegura.anexos.filter(a => a.tipo_arquivo?.startsWith('image/')).map((anexo) => (
                    <div key={anexo.id} className="relative group rounded-lg overflow-hidden border border-red-200 bg-white">
                      {thumbnails[anexo.id] ? (
                        <img
                          src={thumbnails[anexo.id]}
                          alt={anexo.nome_arquivo}
                          className="w-full h-32 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                          onClick={() => setPreviewImage(thumbnails[anexo.id])}
                          data-testid={`thumbnail-${anexo.id}`}
                        />
                      ) : (
                        <div className="w-full h-32 flex items-center justify-center bg-gray-100">
                          <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
                        </div>
                      )}
                      <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-xs p-1.5 truncate">
                        {anexo.nome_arquivo}
                      </div>
                      <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={() => handleDownloadAnexo(anexo)}
                          className="p-1 bg-white/90 rounded-full shadow hover:bg-white"
                          title="Baixar"
                        >
                          <Download className="h-3.5 w-3.5 text-blue-600" />
                        </button>
                        {(user?.perfil === 'ADMIN' || user?.perfil === 'BKO' || user?.perfil === 'BKO_MAILING') && (
                          <button
                            onClick={() => handleExcluirAnexo(anexo)}
                            className="p-1 bg-white/90 rounded-full shadow hover:bg-white"
                            title="Excluir"
                          >
                            <Trash2 className="h-3.5 w-3.5 text-red-600" />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* Lista de PDFs / outros */}
              {vendaSegura.anexos.filter(a => !a.tipo_arquivo?.startsWith('image/')).map((anexo) => (
                <div 
                  key={anexo.id} 
                  className="flex items-center justify-between p-3 bg-white rounded-lg border border-red-200 hover:border-red-300 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <FileText className="h-5 w-5 text-red-500" />
                    <div>
                      <p className="font-medium text-gray-900">{anexo.nome_arquivo}</p>
                      <p className="text-xs text-gray-500">
                        {formatFileSize(anexo.tamanho)} - Enviado por {anexo.enviado_por} em{' '}
                        {format(new Date(anexo.enviado_em), "dd/MM/yyyy 'as' HH:mm", { locale: ptBR })}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleDownloadAnexo(anexo)}
                      className="text-red-600 border-red-300 hover:bg-red-50"
                    >
                      <Download className="h-4 w-4" />
                    </Button>
                    {(user?.perfil === 'ADMIN' || user?.perfil === 'BKO' || user?.perfil === 'BKO_MAILING') && (
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleExcluirAnexo(anexo)}
                        className="text-red-600 border-red-300 hover:bg-red-50"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <Paperclip className="h-12 w-12 mx-auto mb-3 text-gray-300" />
              <p>Nenhum anexo adicionado</p>
              <p className="text-sm mt-1">Clique em &quot;Anexar Arquivo&quot; para adicionar fotos, prints ou PDFs</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Histórico */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <History className="h-5 w-5" />
            Histórico
          </CardTitle>
        </CardHeader>
        <CardContent>
          {vendaSegura.historico?.length > 0 ? (
            <div className="space-y-3">
              {[...vendaSegura.historico].reverse().map((item, index) => {
                const isCampoAlterado = item.acao?.includes('Campos alterados') || item.detalhes?.includes('Alterações:');
                const isStatus = item.acao?.includes('Status');
                const isCriacao = item.acao?.includes('criada');
                const isCorrecao = item.acao?.includes('corrigida');

                // Separar alterações individuais dos detalhes
                let alteracoes = [];
                let detalhesBase = item.detalhes || '';
                if (item.detalhes?.includes('|')) {
                  const parts = item.detalhes.split('|');
                  detalhesBase = parts[0].trim();
                  const altPart = parts.slice(1).join('|').replace('Alterações:', '').trim();
                  alteracoes = altPart.split(';').map(a => a.trim()).filter(Boolean);
                } else if (isCampoAlterado && item.detalhes) {
                  alteracoes = item.detalhes.split(';').map(a => a.trim()).filter(Boolean);
                  detalhesBase = '';
                }

                return (
                  <div key={index} className={`flex gap-3 p-3 rounded-lg border ${
                    isStatus ? 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800' :
                    isCorrecao ? 'bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800' :
                    isCampoAlterado ? 'bg-purple-50 border-purple-200 dark:bg-purple-900/20 dark:border-purple-800' :
                    isCriacao ? 'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800' :
                    'bg-gray-50 border-gray-200 dark:bg-gray-800 dark:border-gray-700'
                  }`}>
                    <div className={`w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0 ${
                      isStatus ? 'bg-red-500' :
                      isCorrecao ? 'bg-amber-500' :
                      isCampoAlterado ? 'bg-purple-500' :
                      isCriacao ? 'bg-green-500' :
                      'bg-gray-400'
                    }`} />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="font-semibold text-sm text-gray-900 dark:text-white">{item.usuario}</span>
                        <span className="text-xs text-gray-400">
                          {format(new Date(item.data_hora), "dd/MM/yyyy 'as' HH:mm", { locale: ptBR })}
                        </span>
                      </div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mt-0.5">{item.acao}</p>
                      {detalhesBase && (
                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{detalhesBase}</p>
                      )}
                      {alteracoes.length > 0 && (
                        <div className="mt-2 space-y-1">
                          {alteracoes.map((alt, i) => {
                            const [campo, ...resto] = alt.split(':');
                            const valor = resto.join(':').trim();
                            return (
                              <div key={i} className="flex items-start gap-2 text-xs">
                                <span className="font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap min-w-[100px]">{campo?.trim()}:</span>
                                <span className="text-gray-500 dark:text-gray-400 break-all">{valor}</span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-gray-500 italic">Nenhum histórico disponível</p>
          )}
        </CardContent>
      </Card>

      {/* Modal de Troca de Vendedor */}
      <Dialog open={modalTrocaAberto} onOpenChange={setModalTrocaAberto}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <UserCog className="h-5 w-5 text-orange-600" />
              Trocar Vendedor
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Vendedor atual:</p>
              <p className="font-semibold text-gray-900">{vendaSegura.vendedor_nome}</p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="novoVendedor">Novo Vendedor *</Label>
              <Select
                value={novoVendedorId}
                onValueChange={setNovoVendedorId}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o novo vendedor" />
                </SelectTrigger>
                <SelectContent>
                  {vendedores
                    .filter(v => v.id !== vendaSegura.vendedor_id)
                    .map((vendedor) => (
                      <SelectItem key={vendedor.id} value={vendedor.id}>
                        {vendedor.nome} ({vendedor.email})
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="motivo">Motivo da Troca *</Label>
              <Textarea
                id="motivo"
                value={motivoTroca}
                onChange={(e) => setMotivoTroca(e.target.value)}
                placeholder="Informe o motivo da troca de vendedor (ex: roubo de venda, solicitação do cliente, etc.)"
                rows={3}
              />
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
              <p className="text-sm text-yellow-800">
                <strong>Atenção:</strong> Esta ação será registrada no histórico da venda e no log de auditoria.
              </p>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setModalTrocaAberto(false)} disabled={trocando}>
              Cancelar
            </Button>
            <Button 
              onClick={handleTrocarVendedor} 
              disabled={trocando || !novoVendedorId || !motivoTroca.trim()}
              className="bg-orange-600 hover:bg-orange-700"
            >
              {trocando ? 'Trocando...' : 'Confirmar Troca'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Preview de Imagem */}
      {previewImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setPreviewImage(null)}
          data-testid="image-preview-modal"
        >
          <div className="relative max-w-4xl max-h-[90vh]">
            <button
              onClick={() => setPreviewImage(null)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <X className="h-8 w-8" />
            </button>
            <img
              src={previewImage}
              alt="Preview"
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DetalhesVenda;
